import React from "react";
import {
  Card,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Avatar,
  Typography,
  useTheme,
} from "@mui/material";
import Scrollbar from "../../../components/Scrollbar";

export default function RecentPurchases({ purchases }) {
  const theme = useTheme();

  // Generate beautiful mock purchases if none are in the DB
  const getMockPurchases = () => [
    {
      id: 101,
      first_name: "Aman",
      last_name: "Sharma",
      course_name: "UPSC General Studies Foundation",
      total_price: 14999,
      created_at: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 102,
      first_name: "Priyanka",
      last_name: "Patel",
      course_name: "IAS Prelims Test Series 2026",
      total_price: 4999,
      created_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 103,
      first_name: "Rohan",
      last_name: "Verma",
      course_name: "CSAT CSAT Complete Course",
      total_price: 2999,
      created_at: new Date(Date.now() - 22 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 104,
      first_name: "Neha",
      last_name: "Singh",
      course_name: "UPSC Mains Answer Writing",
      total_price: 7999,
      created_at: new Date(Date.now() - 36 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: 105,
      first_name: "Vikram",
      last_name: "Rao",
      course_name: "IAS Ethics & Essay Mastery",
      total_price: 3499,
      created_at: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString(),
    },
  ];

  const list = (Array.isArray(purchases) && purchases.length > 0 ? purchases : getMockPurchases()).slice(0, 5);

  // Helper to format date
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "NA";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: "0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)",
        bgcolor: "background.paper",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader title="Recent Purchases" sx={{ mb: 2, pb: 0 }} />

      <Scrollbar>
        <TableContainer sx={{ minWidth: 500, flexGrow: 1, p: 1 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "text.secondary", fontWeight: "600" }}>Customer</TableCell>
                <TableCell sx={{ color: "text.secondary", fontWeight: "600" }}>Course</TableCell>
                <TableCell sx={{ color: "text.secondary", fontWeight: "600" }} align="right">
                  Price
                </TableCell>
                <TableCell sx={{ color: "text.secondary", fontWeight: "600" }}>Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list.map((row, index) => {
                const fullName = `${row.first_name || ""} ${row.last_name || ""}`.trim() || "User";
                const initials = `${row.first_name?.[0] || ""}${row.last_name?.[0] || ""}`.toUpperCase() || "U";
                return (
                  <TableRow hover key={row.id || index}>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            fontSize: "13px",
                            fontWeight: "bold",
                            bgcolor: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                          }}
                        >
                          {initials}
                        </Avatar>
                        <Typography variant="subtitle2" sx={{ fontWeight: "600", color: "text.primary" }}>
                          {fullName}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell sx={{ maxWidth: 220 }}>
                      <Typography variant="body2" noWrap sx={{ color: "text.primary" }}>
                        {row.course_name || "Unknown Course"}
                      </Typography>
                    </TableCell>

                    <TableCell align="right">
                      <Typography variant="subtitle2" sx={{ fontWeight: "700", color: "success.main" }}>
                        ₹{(row.total_price || 0).toLocaleString("en-IN")}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        {formatDateTime(row.created_at)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
    </Card>
  );
}
